import { SidebarHeader, IconButton, Drawer } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { MetadataNotifications } from 'app/domains/metadata';
import { NavigationMenu } from './NavigationMenu';
import { useMobileNavigation } from '../MobileNavigation';
import { AlignRight, StyledLogoType, StyledMobileSidebar } from './styled';
export function Mobile() {
    const { isOpen, close } = useMobileNavigation();
    return (<Drawer open={isOpen} position="left">
      <StyledMobileSidebar>
        <SidebarHeader>
          <StyledLogoType />
          <AlignRight>
            <MetadataNotifications />
            <IconButton $round appearance="ghost" size="small" onClick={close}>
              <Falcon icon="close"/>
            </IconButton>
          </AlignRight>
        </SidebarHeader>
        <NavigationMenu />
      </StyledMobileSidebar>
    </Drawer>);
}
